module.exports = __webpack_public_path__ + "static/img/kwh_item_image4.e75fe67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_item_image4.png
// module id = 8+pA
// module chunks = 1